import type {Selector} from 'react-redux';

import type {AppState} from 'core/types';

import {NAME} from './constants';

const getModel = (state: AppState) => state[NAME];

export const isInitialized: Selector<AppState, boolean> = (state) => getModel(state).initialized ?? false;
